import React, { useEffect } from 'react'
import { Container, Row } from 'react-bootstrap';

export const Brand = () => {

    

    const brand =[
        {
            img: '/assets/images/brand-1.png'
        },
        {
            img: '/assets/images/brand-2.png'
        },
        {
            img: '/assets/images/brand-3.png'
        },
        {
            img: '/assets/images/brand-4.png'
        }
    ]


    useEffect(() => {
        window.$(".two").owlCarousel({
            margin: 30,
            rtl: true,
            dots: false,
            fluidSpeed: true,
            smartSpeed: 5000,
            slideTransition: 'linear',
            autoPlayTimeout: 0,
            autoplay: true,
            loop: true,
            responsive: {
                0: {
                    items: 2,
                },
                400: {
                    items: 2,
                },
                768: {
                    items: 3,
                },
                992: {
                    items: 5,
                },
                1200: {
                    items: 6,
                }
            },
            
        });
       
    }, []);

    useEffect(() => {
        window.$(".one").owlCarousel({
            margin: 30,
            rtl: false,
            dots: false,
            fluidSpeed: true,
            smartSpeed: 5000,
            slideTransition: 'linear',
            autoPlayTimeout: 0,
            autoplay: true,
            loop: true,
            responsive: {
                0: {
                    items: 2,
                },
                400: {
                    items: 2,
                },
                768: {
                    items: 3,
                },
                992: {
                    items: 5,
                },
                1200: {
                    items: 6,
                }
            },
            
        });
       
    }, []);



  return (
    <section className='brand-section'>
        <Container>
            <h5 className='service-text' data-aos="fade-right" data-aos-duration="3000">Our Clients</h5>

            <div className='testi-flex'>
                <div data-aos="fade-right" data-aos-duration="3000">
                    <h4>Top Companies Trust Us</h4>
                </div>
            </div>
        </Container>


        <div className='brand-bg'>
            <Row className='justify-content-center'>
                <div className='col-lg-11 col-md-10 brand-padding'>
                    <div className="owl-carousel owl-theme two">
                        {
                            brand.map((bLogo,index)=>(
                                <div className='item' key={index}>
                                    <div className='brand-border'>
                                        <div className='brand-img'>
                                        <img src={bLogo.img} alt="" />
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <div className='col-lg-11 col-md-10'>
                    
                    <div className="owl-carousel owl-theme one">
                        {
                            brand.map((bLogo,index)=>(
                                <div key={index} className='item '>
                                    <div key={index} className='brand-border'>
                                        <div className='brand-img'>
                                        <img src={bLogo.img} alt="" />
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </Row>
        </div>
    </section>
  )
}